import React, { useContext, useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { UserContext } from '../auth/context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faSpinner } from '@fortawesome/free-solid-svg-icons';
import useClientes from './services/useClientes';
import { back } from '../../helpers/dataServer';

export const ItemUsuarioClienteSelect = ({
  usuario,
  abierto,
  toggleAcordeon,
  setClientesActualizados,
}) => {
  const [clientesCheck, setClientesCheck] = useState([]);
  const [clientesDesmarcados, setClientesDesmarcados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('');
  const { dataUser } = useContext(UserContext);
  const { token, id } = dataUser;

  const { clientes, usuarioClientes, setUsuarioClientes } = useClientes(
    token,
    id,
    filter
  );

  useEffect(() => {
    setClientesCheck(usuarioClientes);
  }, [usuarioClientes]);

  const handleCheckboxChange = (clienteId) => {
    setClientesCheck((prev) =>
      prev.includes(clienteId)
        ? prev.filter((id) => id !== clienteId)
        : [...prev, clienteId]
    );

    setClientesDesmarcados((prev) =>
      prev.includes(clienteId)
        ? prev.filter((id) => id !== clienteId)
        : [...prev, clienteId]
    );
  };

  const handleGrabarClick = async (event) => {
    event.stopPropagation();
    if (clientesCheck.length === 0) {
      Swal.fire(
        'Advertencia',
        'No se ha seleccionado ningún cliente.',
        'warning'
      );
      return;
    }
    setIsLoading(true);

    try {
      await Promise.all(
        clientesDesmarcados.map((clienteId) =>
          fetch(`${back}/usuarioclientes/`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({
              id_usuario: usuario.id,
              id_cliente: clienteId,
            }),
          })
        )
      );

      const response = await fetch(`${back}/usuarioclientes/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          id_usuario: usuario.id,
          id_cliente: clientesCheck,
        }),
      });

      if (response.ok) {
        setUsuarioClientes(clientesCheck);
        setClientesActualizados(clientesCheck);
        Swal.fire('Éxito', 'Clientes asignados correctamente.', 'success');
      } else {
        Swal.fire('Error', 'No se pudo actualizar la información.', 'error');
      }
    } catch (error) {
      console.error('Error en la solicitud:', error);
    } finally {
      setIsLoading(false);
      toggleAcordeon();
    }
  };

  const filteredClientes = filter
    ? clientes.filter((cliente) =>
        cliente.denominacion.toLowerCase().includes(filter.toLowerCase())
      )
    : clientes;

  return (
    <div>
      <button id="openfilterClients" onClick={toggleAcordeon}></button>
      {abierto && (
        <div className="miDiv" onClick={(e) => e.stopPropagation()}>
          <input
            type="text"
            placeholder="Buscar cliente..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="buscarClientes"
          />

          <div className="modal-interior">
            {filteredClientes.length > 0 ? (
              filteredClientes.map((cliente) => (
                <div key={cliente.id} className="clienteItem">
                  <input
                    type="checkbox"
                    id={`cbox-${cliente.id}`}
                    value={cliente.id}
                    checked={clientesCheck.includes(cliente.id)}
                    onChange={() => handleCheckboxChange(cliente.id)}
                  />
                  <label htmlFor={`cbox-${cliente.id}`}>
                    {cliente.denominacion}
                  </label>
                </div>
              ))
            ) : (
              <p>No hay clientes disponibles.</p>
            )}
          </div>
          <button
            className="btnSaveClient"
            onClick={handleGrabarClick}
            disabled={isLoading}
          >
            {isLoading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faFloppyDisk} />
            )}
            <span>Grabar</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemUsuarioClienteSelect;
